import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Loader, LoaderService } from '../common/loader/loader.service';
import { LoginService } from '../login/login.service';
import { TokenService } from '../token/token.service';
import { Token } from '../token/token';
import { environment } from '../../environments/environment';
import { ApplicationService } from '../application/application.service';
import { AuthenticationService } from 'app/authentication/authentication/authentication.service';

@Component({
    selector: 'zest-redirect',
    templateUrl: './redirect.component.html',
    styleUrls: ['./redirect.component.scss']
})
export class RedirectComponent implements OnInit {

    private jwtHelper: JwtHelperService = new JwtHelperService();

    constructor(private route: ActivatedRoute, private tokenService: TokenService, private loaderService: LoaderService, private loginService: LoginService, private applicationService: ApplicationService, private authenticationService: AuthenticationService, private router: Router) { }

    ngOnInit() {
        this.loaderService.ShowLoaderSource.next(new Loader(true, ''));
        this.applicationService.removeSavedApplication();
        this.route.queryParams.subscribe(queryParams => {
            if (queryParams.token) {
                this.applicationService.getDecryptedToken(queryParams.token).subscribe(res => {
                    const token = new Token(res.token);
                    this.tokenService.saveToSession(token);
                    if (queryParams.bankDetailsSetup && queryParams.setupRepayment) {
                        setTimeout(() => {
                            this.router.navigate(['/features/bank-details-setup']);
                        }, 500);
                    } else {
                        setTimeout(() => {
                            // this.tokenService.setMixPanelUserId();
                            if (queryParams.CLReactivation) {
                                this.tokenService.setReactivationContext();
                            }
                            this.router.navigate(['/loggedinredirect']);
                        }, 500);
                    }
                });
            }
            // if (queryParams.mixpanelId) {
            //    this.tokenService.setMixpanelId(queryParams.mixpanelId);
            // }
            if (queryParams.access_token && queryParams.access_token.length > 0) {
                const access_token = queryParams.access_token;
                const customerId = this.jwtHelper.decodeToken(access_token) ? this.jwtHelper.decodeToken(access_token).sub : null;
                if (customerId && customerId.length > 0 && queryParams.post_login_redirect_url && queryParams.post_login_redirect_url.length > 0) {
                    const token = new Token(access_token);
                    this.tokenService.saveToSession(token);
                    // this.tokenService.setMixPanelUserId();
                    // DON'T CHANGE THIS LINE TO ROUTER NAVIGATE - This takes care of navigating to payment-app or to gift-card-redeem app
                    window.location.href = window.location.protocol + '//' + window.location.host + queryParams.post_login_redirect_url;
                } else {
                    this.goToCustomizedFlow(queryParams);
                }
            } else if (queryParams.type && queryParams.page && queryParams.merchant && queryParams.merchantCustomerId) {
                this.setPartnerRedirection(queryParams);
            } else {
                this.goToCustomizedFlow(queryParams);
            }
        });
    }
    goToCustomizedFlow(queryParams) {
        let utmParams = false;
        if (queryParams.hideGmail) {
            this.tokenService.setHideGmail(true);
        }
        if (queryParams.isOfflineGCAgent) {
            this.tokenService.setOfflineGcAgent(true);
        }
        if (queryParams.merchant) {
            if (queryParams.merchant === environment.plMerchantKey) {
                window.location.href = environment.plDeepLink;
            }
            const merchantKey = encodeURIComponent(queryParams.merchant);
            this.tokenService.setReferMerchantKey(merchantKey);
            // Store last merchant context for 45 minutes
            this.tokenService.setWithExpiry('ngx-webstorage|last-merchant-id', merchantKey, 1800000);
        }
        const checkoutParams = this.tokenService.getCheckoutParams();
        if (checkoutParams) {
            this.tokenService.setWithExpiry('ngx-webstorage|last-transaction-context', 900000);
        }
        if (queryParams.merchantCustomerId) {
            this.tokenService.setMerchantCustomerId(queryParams.merchantCustomerId);
        }
        if (queryParams.utm_source && queryParams.utm_medium && queryParams.utm_campaign) {
            utmParams = true;
            this.tokenService.updateAndSetGlobalParams('Utm_Source', queryParams.utm_source);
            this.tokenService.updateAndSetGlobalParams('Utm_Medium', queryParams.utm_medium);
            this.tokenService.updateAndSetGlobalParams('Utm_Campaign', queryParams.utm_campaign);
        }
        if (queryParams.setupSi) {
            this.tokenService.setRedirectToSiFeaturePage(true);
        }
        if (queryParams.setupRepayments) {
            this.goToARSetupPage();
        }
        if (queryParams.kycVerificationSetup) {
            const linkValidations = queryParams.validations ? true : false;
            this.tokenService.setLinkValidations(linkValidations);
            this.goToKycPage(true);
        }
        if (queryParams.kycVerificationSetupV2) {
            const linkValidations = queryParams.validations ? true : false;
            this.tokenService.setLinkValidations(linkValidations);
            this.goToKycPage(queryParams.okyc ? true : false, 'v2');
        }
        if (queryParams.perfiosOnly) {
            this.tokenService.setPerfiosLink();
        }
        if (queryParams.videoKycOnly) {
            this.tokenService.setVideoKycLink();
        }
        if (queryParams.clIncreaseOnly) {
            const flow = queryParams.myaccounts ? 'my-accounts' : 'link';
            this.tokenService.setClIncreaseLink(true, flow);
        }
        if (queryParams.restructuringLA) {
            const { applicationId, merchantId } = queryParams;
            this.tokenService.setRestructuredApplication({applicationId, merchantId});
            this.tokenService.setRestructuringLAFlag();
        }
        if (queryParams.showSanctionLetter) {
            this.tokenService.setShowSanctionLetterPage(queryParams);
        }
        // if (queryParams.moratoriumOptout) {
        //     this.tokenService.setMoratoriumOptoutFlag(true, queryParams.moratoriumOptedInUser);
        //     if (queryParams.moratoriumOptedInUser) {
        //         this.router.navigate(['/features/moratorium-optin-user']);
        //         return;
        //     }
        // }
        if (queryParams.crossSell && queryParams.productId) {
            this.tokenService.setCrossSellProduct(queryParams.productId);
        }
        if (queryParams.sessionId) {
            const token = new Token(queryParams.sessionId);
            this.tokenService.saveToSession(token);
            this.router.navigate(['/loggedinredirect']);
        } else if (!utmParams) {
            this.loginService.goToLoginUrl((queryParams.setupSi || queryParams.setupRepayments) ? false : true);
        } else {
            this.loginService.goToLoginUrlWithUtmParams((queryParams.setupSi || queryParams.setupRepayments) ? false : true, queryParams.utm_source, queryParams.utm_medium, queryParams.utm_campaign);
        }
    }
    setPartnerRedirection(queryParams) {
        const partnerTokenPayload = {
            merchantId: encodeURIComponent(queryParams.merchant),
            merchantCustomerGuId: queryParams.merchantCustomerId,
            type: queryParams.type,
            page: queryParams.page
        };
        this.authenticationService.getPartnerToken(partnerTokenPayload).subscribe(response => {
            const access_token = response.token;
            const customerId = response.customerId;
            if (customerId && customerId.length > 0) {
                const token = new Token(access_token);
                this.tokenService.saveToSession(token);
                if (queryParams.repaymentMode) {
                    response.repaymentMode = queryParams.repaymentMode;
                }
                this.tokenService.setPartnerRedirectDetails(response);
                if (response.page === 'KYC') {
                    this.goToKycPage(true);
                } else if (response.page === 'ARSETUP') {
                    this.goToARSetupPage();
                } else {
                    this.tokenService.removeAll(true);
                }
                // DON'T CHANGE THIS LINE TO ROUTER NAVIGATE - This takes care of navigating to payment-app or to gift-card-redeem app
                this.router.navigate(['/loggedinredirect']);
            } else {
                this.goToCustomizedFlow(queryParams);
            }
        }, error => {
            this.goToCustomizedFlow(queryParams);
        });
    }
    goToKycPage(enableOKYC: boolean, version = 'v1') {
        this.tokenService.setKycVerification(true, enableOKYC, version);
    }
    goToARSetupPage() {
        this.tokenService.setRedirectToRepaymentsFeaturePage(true);
    }
}
